export const MEDICAL_PRODUCT = "Medical"
export const ONLINE_GP_PRODUCT = "Online GP"
export const EAP_PRODUCT = "EAP"
export const FLEXI_PRODUCT = "Flexi-Points"
export const FLEXI = "Flexi"
export const FLEXI_POINTS_PREFIX = "flexi points"
export const NO_EAP = "No EAP"
